import './style.scss';

import {
  INPUT_TYPE,
  MORE_ORDER_TEXT,
  MORE_RR_REQUEST_TEXT,
  ORDER_SHOW_TYPE,
  SELECT_ORDER_TEXT,
  SELECT_RR_REQUEST_TEXT,
  TRACKING_MSG_TYPE,
  TRACKING_TYPE,
  OrderCardType,
  TRACKING_OPERATION,
  TRACKING_TARGET,
  TRACKING_SECTION,
  VIEW_ALL_TEXT,
  VIEW_ALL_ORDERS_TEXT,
} from '@/utils/constants';
import { handleRequest } from '@/utils';
import { addDialogue } from '@/utils/sessionUtils';
import { inject, observer } from 'mobx-react';

import Order from '@/components/Order';
import React from 'react';
import SingleButton from '@/components/SingleButton';
import { USER_SEND_TYPE } from '@/types/history';
import { isNum, getTrans, getChildInject } from '@/utils/instantLoaded/tools';
import moreOrderImage from '@/assets/img/order_others@2x.png';

import { tracker, dispatchTrack } from '@/utils/tracking';
import { handleOrderRedirect } from '@/utils/btnClickHandler';
import { handleClickHistoryButton } from '@/utils/tools';
import { ScrollType, ElementScrollTrackManage } from '@/utils/tracking/utils/elmentScrollTrack';
import { agentStore } from '@/stores';

const PREFIX = 'order-list-container';

export const orderCardStyleMap = {
  [OrderCardType.oldCarousel]: '',
  [OrderCardType.newCarousel]: 'new-carousel',
  [OrderCardType.bigCarousel]: 'big-carousel',
  [OrderCardType.verticalList]: 'vertical-list',
  [OrderCardType.twoRowCarousel]: 'two-row-carousel',
};

export const orderTrackingNameMap = {
  [OrderCardType.oldCarousel]: TRACKING_TYPE.ORDER,
  [OrderCardType.newCarousel]: TRACKING_TYPE.NEW_CAROUSEL_ORDER_CARD,
  [OrderCardType.bigCarousel]: TRACKING_TYPE.BIG_CAROUSEL_ORDER_CARD,
  [OrderCardType.verticalList]: TRACKING_TYPE.VERTICAL_LIST_ORDER_CARD,
  [OrderCardType.twoRowCarousel]: TRACKING_TYPE.TWO_ROW_CAROUSEL_ORDER_CARD,
};

export const otherOrderTrackingNameMap = {
  [OrderCardType.oldCarousel]: TRACKING_TYPE.OTHERORDER,
  [OrderCardType.newCarousel]: TRACKING_TYPE.NEW_CAROUSEL_OTHER_ORDER,
  [OrderCardType.bigCarousel]: TRACKING_TYPE.BIG_CAROUSEL_OTHER_ORDER,
  [OrderCardType.verticalList]: TRACKING_TYPE.VERTICAL_LIST_OTHER_ORDER,
  [OrderCardType.twoRowCarousel]: TRACKING_TYPE.TWO_ROW_CAROUSEL_OTHER_ORDER,
};
@tracker
@inject(getChildInject('initStore', 'modalStore', 'sessionStore'))
@observer
export default class OrderList extends React.PureComponent {
  static defaultProps = {
    // props
    dialogueId: '',
    dialogueType: '',
    node_id: '',
    has_more: 0,
    order_list: [],
    show_type: ORDER_SHOW_TYPE.ORDER_BOT,
    isForRR: false, // RR 专用
    // stores
    initStore: {},
    modalStore: {},
  };

  constructor(props) {
    super(props);
    const { orderCardType = OrderCardType.oldCarousel } = props;
    this.trackingname = orderTrackingNameMap[orderCardType];
    this.trackingnameOther = otherOrderTrackingNameMap[orderCardType];
    this.state = { isFirstCloseModal: true };
    this.elementScrollTrack = new ElementScrollTrackManage();
    this.ordersRef = React.createRef();
    this.containerRef = React.createRef();
  }

  handleChooseOrderClick = (order) => () => handleOrderRedirect(order);

  useForbidOrderRedirect = () => {
    const forbidOrderRedirectCountries = ['co', 'cl'];
    const { is_seller } = this.props;
    if (is_seller && forbidOrderRedirectCountries.includes(COUNTRY)) {
      return true;
    }

    return false;
  };

  handleOrderClick = (order, index) => () => {
    const {
      dialogueId, dialogueType, node_id, isForRR,
      initStore, sessionStore, nodePointId, taskbotName,
      isHistory, historyDialogueId, historySessionId,
      customCallback = {}, customSelectClick, disableButtons,
    } = this.props;
    const { sessionId } = initStore;
    const { inNewFlowBeforeAgent } = agentStore;

    const trackingname = this.trackingname;
    const trackingdata = {
      node_point_id: nodePointId,
      chat_session_id: isHistory ? historySessionId : (sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      button_text: getTrans(isForRR ? SELECT_RR_REQUEST_TEXT : SELECT_ORDER_TEXT),
      button_id: order.button_id,
      button_type: order.button_type,
      orderid: order.order_id,
      location: index,
      task_bot_name: taskbotName,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };

    if (disableButtons) {
      return;
    }
    // 点击埋点
    this.trackingHandler(trackingname, trackingdata);

    const curPos = addDialogue({
      dialogueId,
      dialogueType,
      from: 'user',
      type: 'Order',
      data: {
        ...order,
        shouldRedirect: !this.useForbidOrderRedirect(),
        handleClick: this.handleChooseOrderClick(order),
      },
    });

    if (inNewFlowBeforeAgent) {
      customSelectClick?.(order, index);
      return;
    }

    if (isNum(curPos)) {
      // 非check RR status情况（无orderSN字段），记录展示的order的sn
      !isForRR && sessionStore.ADD_ORDER_SN(order?.order_sn);

      if (order?.return_id) {
        sessionStore.SET_ORDER_INFO_DATA({
          return_sn: order?.return_sn,
          return_id: order?.return_id,
        });
      }

      const params = {
        return_id: order?.return_id,
        order_id: order?.order_id,
        user_send: {
          type: USER_SEND_TYPE.ORDER_SELECT,
          order_select: {
            ...order,
            name: order.title,
            shouldRedirect: !this.useForbidOrderRedirect(),
            id: order?.order_id,
          },
        },
      };

      handleRequest('postMessage', {
        session_id: sessionId,
        dialogue_id: dialogueId,
        input_type: INPUT_TYPE.BUTTON,
        message_text: order.title,
        message_extra: {
          node_id,
          params: params || {},
        },
        ...customCallback,
      });
    }
  };

  handleRequestFaq = () => {
    const { initStore, dialogueId, faq_node_id, isHistory, ext_key_value, customCallback = {}} = this.props;

    // 第一次点击发送请求 FAQ
    if (!this.state.isFirstCloseModal) {
      return;
    }

    if (isHistory) {
      handleClickHistoryButton();
      return;
    }

    handleRequest('postMessage', {
      session_id: initStore?.sessionId,
      dialogue_id: dialogueId,
      input_type: INPUT_TYPE.BUTTON,
      message_text: '',
      message_extra: {
        node_id: faq_node_id,
        ext_key_value,
        params: { order_id: 0 },
      },
      ...customCallback,
    });
    this.setState({ isFirstCloseModal: false });
  };

  handleMoreOrderClick = () => {
    const {
      dialogueId,
      dialogueType,
      node_id,
      modalStore,
      is_seller,
      show_type,
      isForRR,
      nodePointId,
      initStore,
      moreButtonId,
      moreButtonType,
      taskbotName,
      isHistory,
      historyDialogueId,
      historySessionId,
      has_faq,
      customCallback = {},
      customSelectClick,
      disableButtons,
      isSelectOrder,
    } = this.props;

    // 用来
    if (disableButtons) {
      return;
    }

    const trackingname = this.trackingnameOther;
    const trackingdata = {
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      button_id: moreButtonId,
      button_type: moreButtonType,
      button_text: getTrans(isForRR ? MORE_RR_REQUEST_TEXT : MORE_ORDER_TEXT),
      task_bot_name: taskbotName,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };

    // 点击埋点
    this.trackingHandler(trackingname, trackingdata);

    modalStore.SHOW_ORDERLIST_MODAL();
    modalStore.UPDATE_MODAL_ORDER_LIST({
      nodePointId,
      dialogueId,
      dialogueType,
      node_id,
      is_seller,
      show_type,
      isForRR,
      taskbotName,
      isHistory,
      historyDialogueId,
      historySessionId,
      has_faq,
      handleRequestFaq: this.handleRequestFaq,
      customCallback,
      customSelectClick,
    });
    if (isSelectOrder) {
      modalStore.UPDATE_MODAL_ORDER_LIST({
        ...modalStore.modalOrderList,
        isSelectOrder: true,
      });
    }
  };

  // 埋点用 - 点击事件
  trackingHandler = (trackingname, data) => {
    const { tracker } = this.props;

    tracker.click({
      trackingname,
      data,
    });
  };

  renderOrder = (order, index) => {
    if (this.props.orderCardType !== OrderCardType.twoRowCarousel) {
      return this.renderOrderItem(order, index);
    }

    return this.renderTwoRowCarousel(order, index);
  };

  renderTwoRowCarousel = (order, index) => {
    if (index % 2 !== 0) {
      return null;
    }

    return (
      <div className="order-list-item-container" key={order.order_id}>
        {this.renderOrderItem(order, index)}
        {index + 1 < this.props.order_list.length && this.renderOrderItem(this.props.order_list[index + 1], index + 1)}
      </div>
    );
  };

  renderOrderItem = (order, index) => {
    const {
      initStore, dialogueId, isForRR, passedRef, nodePointId,
      taskbotName, isHistory, historyDialogueId, historySessionId, orderCardType = OrderCardType.oldCarousel,
    } = this.props;
    const trackingdata = {
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      button_id: order.button_id,
      button_type: order.button_type,
      button_text: getTrans(isForRR ? SELECT_RR_REQUEST_TEXT : SELECT_ORDER_TEXT),
      location: index,
      orderid: order.order_id,
      task_bot_name: taskbotName,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      order_status: order.status,
    };

    dispatchTrack({
      operation: TRACKING_OPERATION.IMPRESSION,
      target: TRACKING_TARGET[TRACKING_TYPE.LIVE_AGENT_ORDER_INFO_SELECTION],
      section: TRACKING_SECTION[TRACKING_TYPE.LIVE_AGENT_ORDER_INFO_SELECTION],
      data: { viewed_objects: [{ chat_session_id: initStore.sessionId || '' }] },
    });

    return <div
      className="order"
      key={`order-${index}`}
      ref={(ele) => passedRef(ele, index)}
      data-trackingname={this.trackingname}
      data-trackingindex={index}
      data-trackingdata={JSON.stringify(trackingdata)}
    >
      <Order
        {...order}
        orderCardType={orderCardType}
        handleClick={this.handleOrderClick({
          ...order,
          orderCardType: orderCardType === OrderCardType.oldCarousel ? OrderCardType.oldCarousel : OrderCardType.newCarousel,
        }, index)}
      />

      {
        orderCardType !== OrderCardType.verticalList && orderCardType !== OrderCardType.twoRowCarousel && (
          <SingleButton
            className="select-btn"
            handleClick={this.handleOrderClick({
              ...order,
              orderCardType: orderCardType === OrderCardType.oldCarousel ? OrderCardType.oldCarousel : OrderCardType.newCarousel,
            }, index)}
            text={getTrans(isForRR ? SELECT_RR_REQUEST_TEXT : SELECT_ORDER_TEXT)}
          />
        )
      }
    </div>;
  };

  renderMoreOrderBtn = () => {
    const {
      passedRef, order_list, initStore, dialogueId, isForRR,
      nodePointId, moreButtonType, moreButtonId, taskbotName,
      isHistory, historyDialogueId, historySessionId, orderCardType = OrderCardType.oldCarousel,
    } = this.props;
    const moreOrderBtnIndex = order_list.length; // 放在list后
    const trackingdata = {
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      button_id: moreButtonId,
      button_type: moreButtonType,
      button_text: getTrans(isForRR ? MORE_RR_REQUEST_TEXT : MORE_ORDER_TEXT),
      task_bot_name: taskbotName,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };
    const shouldShowIcon
    = orderCardType !== OrderCardType.verticalList && orderCardType !== OrderCardType.twoRowCarousel;

    let moreOrderText = MORE_ORDER_TEXT;

    if (isForRR) {
      moreOrderText = MORE_RR_REQUEST_TEXT;
    }

    if (orderCardType === OrderCardType.verticalList) {
      moreOrderText = VIEW_ALL_TEXT;
    } else if (orderCardType === OrderCardType.twoRowCarousel) {
      moreOrderText = VIEW_ALL_ORDERS_TEXT;
    }

    return (
      <div
        className="more-btn"
        onClick={this.handleMoreOrderClick}
        ref={ele => passedRef(ele, moreOrderBtnIndex)}
        data-trackingname={this.trackingnameOther}
        data-trackingdata={JSON.stringify(trackingdata)}
      >
        <div className="more-btn-container">
          { shouldShowIcon && <img src={moreOrderImage} /> }
          <span>{getTrans(moreOrderText)}</span>
        </div>
      </div>
    );
  };

  addScrollTrackEvent = () => {
    if (this.props.orderCardType === OrderCardType.twoRowCarousel) {
      if (this.ordersRef.current) {
        this.elementScrollTrack.addTrack(this.ordersRef.current, ScrollType.Horizontal, {
          scrollCallback: this.orderScrollTrackHandler,
          containerElement: this.ordersRef.current,
        });
      }
    } else {
      if (this.containerRef.current) {
        this.elementScrollTrack.addTrack(this.containerRef.current, ScrollType.Horizontal, {
          scrollCallback: this.orderScrollTrackHandler,
          containerElement: this.containerRef.current,
        });
      }
    }
  };

  orderScrollTrackHandler = () => {
    const {
      initStore, dialogueId,
      nodePointId, taskbotName,
      isHistory, historyDialogueId, historySessionId,
    } = this.props;
    const trackingdata = {
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      task_bot_name: taskbotName,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };

    dispatchTrack({
      operation: TRACKING_OPERATION.ACTION_SCROLL,
      section: TRACKING_SECTION[this.trackingname] || TRACKING_SECTION.oldCarousel,
      target: '',
      data: trackingdata,
    });
  };

  componentDidMount() {
    this.addScrollTrackEvent();
  }

  componentWillUnmount() {
    this.elementScrollTrack.removeAllTrack();
  }

  render() {
    const {
      has_more,
      order_list,
      orderCardType = OrderCardType.oldCarousel,
      disableButtons,
    } = this.props;
    return (
      <div className={`${PREFIX} ${orderCardStyleMap[orderCardType]}`} ref={this.containerRef} style={{ opacity: disableButtons ? 0.5 : 1, backgroundColor: '#f3f3f3' }} >
        <div
          ref={this.ordersRef}
          className="orders-containter"
        >
          {order_list.map((order, index) => this.renderOrder(order, index))}
        </div>
        {
          has_more && this.renderMoreOrderBtn()
        }
      </div>
    );
  }
}
